export default __webpack_public_path__ + "static/media/rayo_color.44414a84.svg";